import { useMemo } from "react";
import { toast } from "react-toastify";
import { hasMissingAttachmentId, useSendMessageMutation } from "../services/chatService";
import { useGroupChatContext } from "../context/groupchatContext";
import { isPatientChatMessage } from "../helpers/utility";

const useSendPdfToChat = () => {

    const groupChatContext = useGroupChatContext();
    const { selectedChat, messages, setMessages } = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
        messages: groupChatContext.messages,
        setMessages: groupChatContext.setMessages,
    }));

    const [sendMessage, {isLoading: isSending}] = useSendMessageMutation();

    const sendPdfToChat = async (attachedFiles, options = {}) => {
        if (hasMissingAttachmentId(attachedFiles || [])) {
            toast.error("Attachment failed to upload. Please try again.");
            return;
        }
        
        const payload = {
            message: { text: "", type: "message", media: attachedFiles },
            mentions: "",
        };
        if (options?.pid) {
            payload.pid = options.pid;
        } else if (isPatientChatMessage(selectedChat)) {
            payload.pid = selectedChat.pid;
        } else {
            payload.location_id = selectedChat.location_id;
        }
        if (options?.sign_status) {
            payload.sign_status = true;
        }
        if (options?.orig_attach_id) {
            payload.orig_attach_id = options.orig_attach_id;
        }
        if (options?.original_doc_id) {
            payload.original_doc_id = options.original_doc_id;
        }
        if (attachedFiles?.length>0){
           if (attachedFiles[0]?.is_link_to_patient_chart){
            if (payload?.message?.media[0]?.existing_attachment){
                payload.existing_attachment=payload?.message?.media[0]?.existing_attachment;
                delete payload?.message?.media[0]?.existing_attachment;
            }
            payload.is_link_to_patient_chart=payload?.message?.media[0]?.is_link_to_patient_chart;
           }
        }
        try {
            const res = await sendMessage(payload);
            if (res?.data?.code === 0) {
                toast.success(res.data.msg);
                const msgs = [res?.data?.data, ...messages.data];
                setMessages({...messages, data: msgs});
            } else {
                toast.error(res.data.msg);
            }
        }
        catch (error) {
            toast.error("Failed to send message.");
        }
    };

    return { sendPdfToChat, isSending };
};

export default useSendPdfToChat;
